import { render, staticRenderFns } from "./OrgHomeFees.vue?vue&type=template&id=77e0993a&scoped=true&"
import script from "./OrgHomeFees.vue?vue&type=script&lang=js&"
export * from "./OrgHomeFees.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e0993a",
  null
  
)

export default component.exports